import type { ReactElement } from 'react';

export function About(): ReactElement {
  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl md:text-5xl font-heading font-normal text-gray-900 mb-6">
            Welcome the to best airport on Earth.
          </h1>
        </header>
        
        <div className="prose prose-lg max-w-none space-y-6 font-body text-gray-800 leading-relaxed">
          <p>
            Welcome to Border Air Ltd. the biggest little FBO around.
          </p>
          
          <p>
            Opened by George Coy and Mike Reed, Border Air Ltd. has operated the Franklin County airport since 1994.
          </p>
          
          <p>
            Back in the 90's, with its sister companies Yak West and Gesoco Industries, Border Air Ltd. became synonymous with importation and sales of former Soviet Bloc aircraft most notably the Yak-52.
          </p>
          
          <p>
            From 1994 to 2008 Border Air imported over 350 aircraft and became the factory representatives for Aerostar, the manufacturer of the Yak-52 , and MotorStar, the manufacturer of the M14-P radial engine...
          </p>
          
          <p>
            In addition to bringing an international flair to the region, Border Air Ltd has shepherded the growth of the Franklin County Airport from a few buildings with a grass parking lot to a full fledged airport.
          </p>
          
          <p>
            The airport is home to Vermont's premier{' '}
            <a 
              href="http://www.613.eaachapter.org/" 
              className="text-blue-600 hover:text-blue-800 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Experimental Aviation Association Chapter 613
            </a>
            , One of the best voted paint shops in the country:{' '}
            <a 
              href="http://www.paintaircraft.com/" 
              className="text-blue-600 hover:text-blue-800 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prestige Aircraft
            </a>
            , and our successful Independent flight training club: Fly Vermont
          </p>
          
          <p>
            Border Air Ltd provides service and support to all piston aircraft that can land on a 3000′ x 75′ strip (and even a few that can't).
          </p>
          
          <p>
            We took over for Yak-West in the for supplying domestic parts for the Yak-52.
          </p>
          
          <p>
            For factory new & overhauled M14-P engines and parts George opened
          </p>
          
          <p>
            <a 
              href="http://www.motorstarna.com/" 
              className="text-blue-600 hover:text-blue-800 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              MotorStar North America
            </a>
          </p>
          
          <p>
            In 2007, I took over the management of the business from George.
          </p>
          
          <p>
            Our maintenance shop employs some of the best mechanics in the area with over 50 years of combined experience working on a wide range of normal and experimentally certified aircraft from the DC-3 to present.
          </p>
          
          <p>
            Our expertise and experience in the export and the import and certification of GA aircraft is unsurpassed.
          </p>
          
          <p>
            We offer flat rate Annual Inspections and perform Major repairs and engine overhauls.
          </p>
          
          <p>
            Please contact us for any of your aviation needs–you'll be glad you did.
          </p>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="mb-2">
              Best regards,
            </p>
            <p className="font-semibold">
              Clifford Coy
            </p>
            <p className="text-gray-600">
              President
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}